/**
 * Constantes del dominio de Horario: permisos de gating y etiquetas de la rejilla.
 *
 * Los permisos replican los del SSR / la API (`scheduling_controller.py` y
 * `domains/scheduling.py`): la página de horario semanal exige `schedule` y la de
 * horario láser exige `laser_schedule` (mismos nombres que el menú del SSR y que
 * `navConfig.ts`). El detalle de un slot es login-only en ambos (no exige permiso
 * concreto): se pide tras abrir una celda, dentro de una pantalla ya gateada.
 */

/** Permiso que gobierna el Horario semanal (igual que el menú/SSR/API). */
export const SCHEDULE_PERMISSION = "schedule";

/** Permiso que gobierna el Horario láser (igual que el menú/SSR/API). */
export const LASER_SCHEDULE_PERMISSION = "laser_schedule";

/**
 * Cabeceras de los 7 días de la rejilla, de lunes a domingo, en el MISMO orden que
 * el `<thead>` del SSR (`schedule.html`). El backend entrega las celdas en ese
 * orden (`day_offset` 0..6 desde el lunes), así que el índice de la celda mapea con
 * esta etiqueta.
 */
export const DAY_HEADERS = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
] as const;

/** Mensaje genérico ante un error inesperado (no-API). */
export const SCHEDULING_GENERIC_ERROR = "Ocurrió un error inesperado.";
